<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>
            TITLE.TITLE_SHIFT_DETAIL
        </h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid">
        <sk-wave [isRunning]="IsSubmitting"></sk-wave>
        <table class="table">
            <tr>
                <th><input type="checkbox" aria-label="Checkbox for following text input" (change)="SelectAllProperty($event)" [(ngModel)]="AllPropertySelected"></th>
                <th translate>LBL.PROPERTY</th>
                <th translate>LBL.GUEST_CALLS</th>
                <th translate>LBL.STAFF_CALLS</th>
                <th translate *ngIf="HasMNTLicense">LBL.LBL_WORK_ORDERS</th>
                <th translate>LBL.MAPPED_TO_SECTIONS</th>
                <th translate>LBL.STATUS</th>
            </tr>
            <tr *ngFor="let row of Model">
                <td><input type="checkbox" aria-label="Checkbox to select Property" (change)="SelectProperty(row, $event)" [checked]="row.Selected"></td>
                <td><span translate>{{row.PropertyCode}}</span></td>
                <td>{{row.GuestCalls}}</td>
                <td>{{row.StaffCalls}}</td>
                <td *ngIf="HasMNTLicense">{{row.WorkOrders}}</td>
                <td>{{row.SectionsName}}</td>
                <td><span [ngClass]="row.IsLoggedIn ? 'LoggedInStatus':'LoggedOutStatus'" title="{{row.IsLoggedIn ? ('TITLE.TITLE_LOGGED_IN' | translate) : ('TITLE.TITLE_LOGGED_OUT' | translate)}}"><i class="fas fa-user fa-fw"></i></span></td>
            </tr>
        </table>
    </div>
    <div class="modal-footer justify-content-between">
        <div>
            <button type="button" class="btn btn-info mr-3" *ngIf="Model.length > 0" (click)="DisableModalOpenEvent = false;StartShift()" [disabled]="SelectedPropertiesLst.length==0" translate>BTN.BTN_START_SHIFT</button>
            <button type="button" class="btn btn-secondary" *ngIf="Model.length > 0" (click)="DisableModalOpenEvent = false;EndShift()" [disabled]="SelectedPropertiesLst.length==0" translate>BTN.BTN_END_SHIFT</button>
        </div>
        <button type="button" class="btn btn-primary" (click)="DisableModalOpenEvent = false;c('close')" translate>BTN.BTN_CLOSE</button>
    </div>

</ng-template>
<OpenJobsInformation #openJobsInformation></OpenJobsInformation>


